import { Component, OnInit } from '@angular/core';

import { IWidgetEditor, WidgetType, IMultiSourceMultiValueWidget, TimeSeriesDetail } from "src/app/models/dashboard";
import { Widget, Dashboard } from 'src/api/models'

import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";
import { IconService } from 'src/service/icon.service';
import { StorageTablesService } from "src/service/storage-tables.service";

@Component({
  selector: 'app-latest-simple-widget-editor',
  templateUrl: './latest-simple-widget-editor.component.html',
  styleUrls: ['./latest-simple-widget-editor.component.css']
})
export class LatestSimpleWidgetEditorComponent implements OnInit, IWidgetEditor {
    public widgetType: WidgetType;
    public widget: Widget;
    public dashboard: Dashboard;
    public w: IMultiSourceMultiValueWidget;
    public items: Array<any>;
    public activeInput: TimeSeriesDetail;
    //public active: TimeSeriesDetail;
    icons: string[];
    
    constructor(private iconService: IconService) { }

    ngOnInit() {
      this.icons = this.iconService.getIcons();
      this.w = <any>this.widget;
      console.log('latest simple widget editor loaded');
      //this.active = {uri:null} as TimeSeriesDetail;
      if (!this.w.timeSeriesList || this.w.timeSeriesList.length != 1){
        this.w.timeSeriesList = [
          new TimeSeriesDetail()
        ];
      }
      if (this.w.timeSeriesList[0].transforms == null){
        this.w.timeSeriesList[0].transforms = [];
      }
      // get the latest data sources
    }

  private value: any = {};
  private _disabledV: string = '0';
  private disabled: boolean = false;

  private get disabledV(): string {
    return this._disabledV;
  }

  private set disabledV(value: string) {
    this._disabledV = value;
    this.disabled = this._disabledV === '1';
  }

  public selected(value: any): void {
    //console.log('Selected value is: ', value);
    // maybe use this to display the description for the selected data source
    /*if (this.dataSource){
      for (let d of this.dataSource) {
        for (let i of d.inputs) {
          if (i.uri == value) {
            this.activeInput = i;
            this.w.timeSeries.uri = this.activeInput.uri;
            console.debug("activeInput changed to: " + this.activeInput.name);
          }
        }
      }
    }*/
  }

  public removed(value: any): void {
    //console.log('Removed value is: ', value);
  }

  public typed(value: any): void {
    //console.log('New search input: ', value);
  }

  public refreshValue(value: any): void {
    this.value = value;
  }
  
}
